import type { FC } from 'react';
import React from 'react';
import { DamageTyreProblemIcon } from '@THC/components/Icons';
import { InfoBox } from '@THC/components/InfoBox';
import { MDText } from 'i18n-react';

import TextLink from 'Components/shared/TextLink/TextLink';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';

import { hasBodyDamage } from './DamageInfoBox.helpers';
import DamageInfoBoxTexts from './DamageInfoBox.texts';

import styles from './DamageInfoBox.module.scss';

const LocalT = new MDText(DamageInfoBoxTexts);

export const WHEELS_AND_TYRES = 'wheelsAndTyres';

const onClick = () => {
	document.getElementById(WHEELS_AND_TYRES)?.scrollIntoView({ behavior: 'smooth' });
};

export const DamageInfoBox: FC = () => {
	const {
		conditionAndDamage,
		ratings,
		wheelsAndTyres: { hasScuffedAlloy, scuffedAlloyDesc },
	} = useVehicleData();

	const isCleanExceptAlloys =
		ratings.numericGrade &&
		!hasBodyDamage(conditionAndDamage) &&
		hasScuffedAlloy === 'Yes' &&
		Number(scuffedAlloyDesc) > 0;

	return isCleanExceptAlloys ? (
		<div className={styles.container}>
			<InfoBox
				content={''}
				heading={
					<span>
						{LocalT.translate('damageInfo', {
							count: scuffedAlloyDesc,
							link: (
								<TextLink
									onClick={onClick}
									text={`${LocalT.translate(Number(scuffedAlloyDesc) === 1 ? 'linkOne' : 'linkMany')}`}
								/>
							),
						})}
					</span>
				}
				icon={DamageTyreProblemIcon}
			/>
		</div>
	) : null;
};
